import type { Locale } from 'antd/es/locale';
import dayjs from 'dayjs';

const STORAGE_KEY = 'asset.ui-language.v1';
type UiLanguage = 'zh-CN' | 'zh-TW' | 'en-US' | 'ja-JP' | 'ko-KR' | 'vi-VN' | 'th-TH' | 'id-ID';
type LanguageDefinition = {
  htmlLang: string;
  dayjsLocale: string;
  loadAntdLocale: () => Promise<{ default: Locale }>;
  loadDayjsLocale: () => Promise<unknown>;
};
const languages: Record<UiLanguage, LanguageDefinition> = {
  'zh-CN': { htmlLang: 'zh-CN', dayjsLocale: 'zh-cn', loadAntdLocale: () => import('antd/es/locale/zh_CN'), loadDayjsLocale: () => import('dayjs/locale/zh-cn') },
  'zh-TW': { htmlLang: 'zh-TW', dayjsLocale: 'zh-tw', loadAntdLocale: () => import('antd/es/locale/zh_TW'), loadDayjsLocale: () => import('dayjs/locale/zh-tw') },
  'en-US': { htmlLang: 'en-US', dayjsLocale: 'en', loadAntdLocale: () => import('antd/es/locale/en_US'), loadDayjsLocale: () => import('dayjs/locale/en') },
  'ja-JP': { htmlLang: 'ja-JP', dayjsLocale: 'ja', loadAntdLocale: () => import('antd/es/locale/ja_JP'), loadDayjsLocale: () => import('dayjs/locale/ja') },
  'ko-KR': { htmlLang: 'ko-KR', dayjsLocale: 'ko', loadAntdLocale: () => import('antd/es/locale/ko_KR'), loadDayjsLocale: () => import('dayjs/locale/ko') },
  'vi-VN': { htmlLang: 'vi-VN', dayjsLocale: 'vi', loadAntdLocale: () => import('antd/es/locale/vi_VN'), loadDayjsLocale: () => import('dayjs/locale/vi') },
  'th-TH': { htmlLang: 'th-TH', dayjsLocale: 'th', loadAntdLocale: () => import('antd/es/locale/th_TH'), loadDayjsLocale: () => import('dayjs/locale/th') },
  'id-ID': { htmlLang: 'id-ID', dayjsLocale: 'id', loadAntdLocale: () => import('antd/es/locale/id_ID'), loadDayjsLocale: () => import('dayjs/locale/id') },
};

export async function applyUiLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY) as UiLanguage | null;
  const code: UiLanguage = stored && stored in languages ? stored : 'zh-CN';
  const definition = languages[code];
  const [{ default: antdLocale }] = await Promise.all([definition.loadAntdLocale(), definition.loadDayjsLocale()]);
  document.documentElement.lang = definition.htmlLang;
  document.documentElement.dataset.uiLanguage = code;
  dayjs.locale(definition.dayjsLocale);
  return { htmlLang: definition.htmlLang, dayjsLocale: definition.dayjsLocale, antdLocale, code };
}
